import { Box } from "@mui/material"
import { Link } from "react-router-dom"

const VariantBox = (props) =>{
 
    return (
        <>
        <Box component={Link} to={props?.url} sx={{width:'62px', maxWidth:'62px',height:'62px',textDecoration:'none'}}>
            <img src={props.imgurl} style= {{width:'62px', maxWidth:'62px',height:'62px',border:'1px solid',borderRadius:'10px'}}  alt={props?.variant_name} />
        </Box>
        </>
    )

}

export default VariantBox